import {environment as env} from '../../../environments/environment';

export const API_URLS = {

  authService: {
    login: 'auth/login',
    logout: 'auth/logout',
    password: 'auth/password'
  },

  personnelService: {
    personnel: 'personnels',
    category: 'personnel/categories',
    personnelDocs: 'personnel/documents'
  },
  userService: {
    users: 'users'
  },
  fileManagerService: {
    file: 'documents'
  },

  documentService: {
    category: 'document/categories',
    type: 'document/types',
    format: 'document/formats',
    unit: 'list_user_units',
    accesslevels: 'accesslevels',
    template: 'templates',
    workflow: 'workflowconfig'
  },

  miscService: {
    deviceVersion: 'core/admin/mobile-device-update',
    serbianReport: 'wallet/public/serbian/users/transactions',
    transactions: 'transactions/admin',
    role: 'roles',
    permission: 'permissions',
  },

  administrationService: {
    dashboard: 'dashboard',
    units: 'units',
    signature: 'signature'
  },

  dashboardService: {}

};
